import { DeviceTypeEnum } from 'Types/deviceTypes'

export const getRentalsDeviceCategoryTranslationId = (value: string) => {
  switch (value) {
    case DeviceTypeEnum.smartphone:
      return 'RentalsDeviceCategory_smartphone'
    case DeviceTypeEnum.tablet:
      return 'RentalsDeviceCategory_tablet'
    case DeviceTypeEnum.laptop:
      return 'RentalsDeviceCategory_laptop'

    default: {
      return 'RentalsDeviceCategory_other'
    }
  }
}
